<script setup>

import { defineProps, onMounted, ref } from 'vue';

const props = defineProps({
  vert: Boolean,
});

const handle = ref(null)

const emit = defineEmits(['change']);

const from = {
  x: 0, y: 0
}

function mouseMoveListener(e) {
  e.preventDefault();
  e.stopPropagation();

  console.log("moving")

  const dx = - e.pageX + from.x
  const dy = - e.pageY + from.y
  from.x = e.pageX
  from.y = e.pageY

  emit('change', props.vert ? dx : dy)

  // props.valueRef.value = from.val + (props.vert ? dx : dy)

}

function mousedown(e) {
  e.preventDefault();
  e.stopPropagation();

  console.log('moving')

  from.x = e.pageX
  from.y = e.pageY


  handle.value.classList.add('captured')

  document.addEventListener('pointermove', mouseMoveListener, { passive: false })
  document.addEventListener('pointerup', () => {
    document.removeEventListener('pointermove', mouseMoveListener)    
    handle.value.classList.remove('captured')
  }, { passive: false })
}

onMounted(() => {
  handle.value.addEventListener('pointerdown', mousedown, {passive: false})
})

</script>

<template>
  <div ref='handle' :class="['handle', 'bg-base-300',  {vert: vert, hor: !vert}]" >
    <div class="visual-clue"></div>
    <div class="handle-button-holder">
      <div class="handle-button" >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
  .handle {
    display: flex;
    align-items: stretch;
    justify-content: center; 
    touch-action: none;

  }

  .handle-button-holder {
    align-self: center;
    height: 100px;
    position: relative;
    background-color: red;
  }

  .handle-button {
    position: absolute;
    right: -10px;
    top: 0;
    z-index: 801;

    width: 24px;
    height: 40px;


    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 2px;
    touch-action: none; /* prevents unintended scrolling */


    & span {
      width: 1px;
      height: 28px;
      background-color: #777;
      border-radius: 2px;
    }

  }

  .handle.captured .visual-clue, .handle:active .visual-clue {
    visibility: visible;
  }

  @media (hover: hover) {
    .handle:hover .visual-clue {
      visibility: visible;
    }
  }

  .visual-clue {
    flex-basis: 3px;
    background-color: var(--color-primary);
    visibility: hidden;
    pointer-events: none;
  }

  .vert {
    width: 10px;
    min-width: 10px;
    cursor: ew-resize;
    
  }
  .hor {
    height: 10px;
    min-height: 10px;
    cursor: ns-resize;
    flex-direction: column;
  }
</style>
